export default __webpack_public_path__ + "static/media/GetHelp_GettingStarted.cd5dd386.svg";